module.exports = require('../manifest.json').version;